export const pkg = {
  name: 'isomorphic-git',
  version: '0.17.1'
}
